import {
  Button,
  DatePicker,
  Form,
  Input,
  Layout,
  Modal,
  PageHeader,
  Row,
  Select,
  Spin,
  Table,
  Tag,
  Typography,
  InputNumber
} from 'antd';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import ReactTable from 'react-table';
import styled from 'styled-components';
import HeaderComponent from '../../components/HeaderComponent';
import { showError } from '../../utils';

import Tappable from 'react-tappable/lib/Tappable';
import {
  approveRequestStatus,
  fetchAllApprovalRequests,
  updateRequestStatus,
  doctorPracticeApproveRequestStatus,
  centerFulfilmentApproveRequestStatus,
  centerFulfilmentCencelRequest,
  centerFulfilmentApproveRequest,
  updateDiscountForAllSpecialists,
} from '../../services/api/approval-requests';
import {
  getCentersWithBeneficiary
} from '../../services/profiling';

import {
  changeNetworkCenterStatus,
  fetchCenterBasicProfile,
  fetchMoUDetailsForCenter,
  makeCenterStatusActive,
  fetchDoctorProfile,
} from '../../services/profiling';
import moment from 'moment';
import SidebarComponent from '../../components/sidebarComponent';
import app from '../../reducers/app';

const { Option } = Select;
const { TextArea } = Input;
const { Text } = Typography;
const { success, warning } = Modal;
const { Content } = Layout;
const { RangePicker } = DatePicker;

const TappableContainer = styled(Tappable)`
  margin: 10px;
`;


const ApprovalRequests = () => {
  const [approvalRequests, setApprovalRequests] = useState([]);
  const [combinedApprovalRequest, setCombinedApprovalRequest] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showHandleRequestApproval, setShowHandleRequestApproval] = useState(false);
  const [showHandleRequestApprovalMessage, setShowHandleRequestApprovalMessage] = useState('');
  const [selectedRequestId, setSelectedRequestId] = useState(null);
  const [selectedApprovalRequest, setSelectedApprovalRequest] = useState({});
  const [finalPrice, setFinalPrice] = useState(0);
  const [editPrice, setEditPrice] = useState(false);
  const [updateAllCenter, setUpdateAllCenter] = useState(false);
  const [updateAllCenterIdData, setUpdateAllCenterIdData] = useState('');
  const [updateAllCenterNameData, setUpdateAllCenterNameData] = useState('');
  const [finalOpdCharges, setFinalOpdCharges] = useState(0);
  const [centerDetail, setCenterDetail] = useState(null);
  const [centerMouDetail, setCenterMouDetail] = useState(null);
  const [doctorDetail, setDoctorDetail] = useState({});
  const [doctorCenterDetail, setDoctorCenterDetail] = useState({});
  const [filteredParams, setFilteredParams] = useState([]);
  const [remark, setRemark] = useState('');
  const [finalOfflineDiscount, setFinalOfflineDiscount] = useState(0);
  const [finalFollowUpDays, setFinalFollowUpDays] = useState(0);
  const [finalOfflineDiscountOperation, setFinalOfflineDiscountOperation] = useState('percentage');
  const [finalFollowUpDiscount, setFinalFollowUpDiscount] = useState(0);
  const [finalFollowUpDiscountOperation, setFinalFollowUpDiscountOperation] = useState('percentage');
  const [finalPayoutOfflineDiscount, setFinalPayoutOfflineDiscount] = useState(0);
  const [finalPayoutOfflineDiscountOperation, setFinalPayoutOfflineDiscountOperation] = useState('percentage');
  const [finalAppointmentType, setFinalAppointmentType] = useState('prior_appointment');
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [approving, setApproving] = useState(false);
  const [rejecting, setRejecting] = useState(false);
  const [dots, setDots] = useState('.');

  useEffect(() => {
    if (!(approving || rejecting)) {
      setDots('.');
      return;
    }
    const interval = setInterval(() => {
      setDots(d => (d.length >= 4 ? '.' : d + '.'));
    }, 450);
    return () => clearInterval(interval);
  }, [approving, rejecting]);


  // const [remark, se] = useState([]);

  // useEffect(() => {
  //   console.log('[InsideuseEffect1]');
  //   //fetchAllRequests();
  // }, []);

  useEffect(() => {
    setLoading(true);
    if (currentPage !== null && pageSize !== null) {
      fetchAllRequests();
    }
  }, [currentPage, pageSize, filteredParams]);

  useEffect(() => {
    const data = approvalRequests.find(
      ({ requestId }) => requestId === selectedRequestId
    );
    if (data) {
      if (data.updateAll == 1) {
        getCentersWithBeneficiary(data.centerId).then((result) => {
          const allUpdatedCenterId = [];
          const allUpdatedCenterName = [];
          allUpdatedCenterId.push(data.centerId);
          allUpdatedCenterName.push(data.centerName);
          result.result.forEach((res) => {
            allUpdatedCenterId.push(res.centerId);
            allUpdatedCenterName.push(res.name);
          });
          setUpdateAllCenterIdData(allUpdatedCenterId.join(', '))
          setUpdateAllCenterNameData(allUpdatedCenterName.join(', '))
          setSelectedApprovalRequest(data);
          setFinalPrice(data.newOpdCharges);
          setFinalOpdCharges(data.newOpdCharges);
          setFinalAppointmentType(data.newAppointmentType);
          setFinalFollowUpDays(data.newOfflineFollowUpDays);
          setFinalOfflineDiscount(data.newOfflineDiscount);
          setFinalOfflineDiscountOperation(data.newOfflineDiscountOperation);
          setFinalFollowUpDiscount(data.newOfflineFollowUpDiscount);
          setFinalFollowUpDiscountOperation(data.newFOfflineDiscountOperation);
          setFinalPayoutOfflineDiscount(data.newPayoutOfflineDiscount);
          setFinalPayoutOfflineDiscountOperation(data.newOfflineDiscountOperation);
          setShowModal(true);
          setEditPrice(false);
          setUpdateAllCenter(true);
        });

      } else {
        setSelectedApprovalRequest(data);
        setFinalPrice(data.newOpdCharges);
        setFinalOpdCharges(data.newOpdCharges);
        setFinalAppointmentType(data.newAppointmentType);
        setFinalFollowUpDays(data.newOfflineFollowUpDays);
        setFinalOfflineDiscount(data.newOfflineDiscount);
        setFinalOfflineDiscountOperation(data.newOfflineDiscountOperation);
        setFinalFollowUpDiscount(data.newOfflineFollowUpDiscount);
        setFinalFollowUpDiscountOperation(data.newFOfflineDiscountOperation);
        setFinalPayoutOfflineDiscount(data.newPayoutOfflineDiscount);
        setFinalPayoutOfflineDiscountOperation(data.newOfflineDiscountOperation);
        setShowModal(true);
        setEditPrice(false);
        setUpdateAllCenter(false);
        setUpdateAllCenterIdData('')
        setUpdateAllCenterNameData('')
      }
    }
  }, [selectedRequestId]);

  const fetchCenterProfile = async () => {
    const centerDetails = await fetchCenterBasicProfile(
      selectedApprovalRequest.centerId
    );
    const centerMouDetails = await fetchMoUDetailsForCenter(
      selectedApprovalRequest.centerId
    );
    setCenterDetail(centerDetails.centerDetails);
    setCenterMouDetail(centerMouDetails.result);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };


  const fetchDoctorDetail = async (doctorId) => {
    const doctorDetails = await fetchDoctorProfile(doctorId);
    setDoctorDetail(doctorDetails.result.basicProfile[0]);
    setDoctorCenterDetail(doctorDetails.result.practiceCenters[0]);
  };

  useEffect(() => {
    if (selectedApprovalRequest.requestType == 'Center_Onboarding_Request') {
      fetchCenterProfile();
    }
    if (selectedApprovalRequest.requestType == 'Add-Doctor-Request') {
      // console.log(selectedApprovalRequest, 'propd');
      if (selectedApprovalRequest.doctorId) {
        fetchDoctorDetail(selectedApprovalRequest.doctorId);
      }
    }
  }, [selectedApprovalRequest]);

  // useEffect(() => {
  //   const pendingRequests = approvalRequests.filter(
  //     (item) => item.status === 'Pending'
  //   );
  //   const remainingRequests = approvalRequests.filter(
  //     (item) => item.status !== 'Pending'
  //   );
  //   const combinedData = pendingRequests.concat(remainingRequests);

  //   setCombinedApprovalRequest(combinedData);
  // }, [approvalRequests]);

  const onFilteredChange = (e) => {
    console.log(e);
    //setFilteredParams({ filteredParams: e });
    setFilteredParams(e);
    console.log('[filteredParams' + filteredParams);
  };

  const onPageChange = (pageIndex) => {
    console.log('[pageIndex]' + pageIndex);
    setCurrentPage(pageIndex + 1);
    // fetchTableData();
  };

  const fetchTableData = (state) => {
    console.log('[state]' + JSON.stringify(state));
    setCurrentPage(state.page + 1);
    setPageSize(state.pageSize);
    //fetchAllRequests();
  };
  const fetchAllRequests = async () => {
    const params = {
      rowsPerPage: pageSize,
      page: currentPage,
    };

    if (filteredParams.length !== 0) {

      filteredParams.forEach((element) => {
        console.log('element' + element.id + ' ' + element.value);
        if (element.id == 'requestId') params.requestId = element.value;
        if (element.id == 'doctorName') params.doctorName = element.value;
        if (element.id == 'centerName') params.center = element.value;
        if (element.id == 'status') params.status = element.value;
        if (element.id == 'requestType') params.requestType = element.value;
        if (element.id == 'requestComingFrom') params.requestComingFrom = element.value;
        if (element.id == 'requestBy') params.requestedBy = element.value;
        if (element.id == 'createdAt') params.requestedDate = element.value;
        if (element.id == 'approvedAt') params.approvedAt = element.value;
      });
    }

    console.log(params);
    const data = await fetchAllApprovalRequests(params);
    console.log('[totalHits]' + data.body.totalHits);
    data.body.result.map((res) => {
      if (!res.doctorName) {
        res.doctorName = '           -            ';
      }
    });
    if (data.body) {
      const totalPages = Math.ceil(data.body.totalHits / pageSize);
      setPages(totalPages);
      setApprovalRequests(data.body.result);
      setLoading(false);
      console.log(data.body, 'fetchAllRequests');
    }
  };

  const handlePositiveIntegerChange = (value, field) => {
    if(field==='OPD Charges'){
      setFinalOpdCharges(value);
    }
    if ((field ==='Follow up Days')) {
      setFinalFollowUpDays(value);
    }
  };

  const handleDiscountChange = (value, field, type = 'value') => {
    console.log(type, 'operationType');
    if(type==='operation'){
      if(field==='Offline Discount'){
        setFinalOfflineDiscountOperation(value);
      }
      if(field === 'Follow up Discount'){
        setFinalFollowUpDiscountOperation(value);
      }
      if(field === 'Visit Payout Discount'){
        setFinalPayoutOfflineDiscountOperation(value);
      }
    }
    if (type === 'value') {
      if (field === 'Offline Discount') {
        setFinalOfflineDiscount(value);
      }
      if (field === 'Follow up Discount') {
        setFinalFollowUpDiscount(value);
      }
      if (field === 'Visit Payout Discount') {
        setFinalPayoutOfflineDiscount(value);
      }
    }
  };

  console.log(finalOfflineDiscount," --- ", finalFollowUpDiscountOperation, " ---", finalFollowUpDiscount, " ---", finalFollowUpDiscountOperation, 'hinata321');

  const getDiscountValue = (field) => {
    return field === 'Offline Discount'
      ? selectedApprovalRequest.newOfflineDiscount
      : selectedApprovalRequest.newOfflineFollowUpDiscount;
  };

  const getDiscountOperation = (field) => {
    return field === 'Offline Discount'
      ? selectedApprovalRequest.newOfflineDiscountOperation
      : selectedApprovalRequest.newFOfflineDiscountOperation;
  };

  const handleFinalDataChange = (value, field) => {
    updateFinalData(value, field);
  };

  const updateFinalData = (value, field) => {
    // Update the final data for the field in the selectedApprovalRequest or state as needed
  };

  const columns = [
    {
      title: 'Fields',
      dataIndex: 'field',
      key: 'field',
      render: (text) => {
        const fieldDescriptions = {
          'Offline Discount': 'Discount we give to the user (patient).',
          'Visit Payout Discount': 'Discount we take from the center (partner).',
        };
        return (
          <div>
            <a>{text}</a>
            {fieldDescriptions[text] && (
              <div style={{ color: '#cf1322', fontSize: 12, fontWeight: 500, marginTop: 2 }}>
                {fieldDescriptions[text]}
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: 'Current Details',
      dataIndex: 'oldData',
      key: 'oldData',
    },
    {
      title: 'New Details',
      dataIndex: 'newData',
      key: 'newData',
    },
    {
        title: 'Final Details',
        dataIndex: 'finalData',
        key: 'finalData',
        render: (text, record) => {
          
          if (record.field === 'Onboarding Status' || record.field === 'Payout To') {
            return <span>{text}</span>; // Non-editable
          }

          
          if (['OPD Charges', 'Follow up Days'].includes(record.field)) {
            return (
              <InputNumber
                min={0}
                value={text}
                onChange={(value) =>
                  handlePositiveIntegerChange(value, record.field)
                }
                style={{ width: 190 }}
                disabled={selectedApprovalRequest.status !== 'Pending'}
              />
            );
          }

          
          if (['Offline Discount', 'Follow up Discount', 'Visit Payout Discount'].includes(record.field)) {
            return (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <InputNumber
                  value={text.split(' ')[0]}
                  onChange={(value) =>
                    handleDiscountChange(value, record.field)
                  }
                  style={{ width: 80, marginRight: 8 }}
                  disabled={selectedApprovalRequest.status !== 'Pending'}
                />
                <Select
                  defaultValue={text.split(' ')[1] || 'fixed'}
                  onChange={(value) =>
                    handleDiscountChange(value, record.field, 'operation')
                  }
                  style={{ width: 100 }}
                  disabled={selectedApprovalRequest.status !== 'Pending'}
                >
                  <Select.Option value="fixed">Fixed</Select.Option>
                  <Select.Option value="percentage">Percentage</Select.Option>
                </Select>
              </div>
            );
          }

          if(record.field === 'Appointment Type'){
            return (
              <div>
                <Select
                  defaultValue={selectedApprovalRequest.newAppointmentType}
                  onChange={(value) =>{
                    // handleDiscountChange(value, record.field, 'operation');
                    // console.log(value,'naruto');
                    setFinalAppointmentType(value);
                  }}
                  style={{ width: 190 }}
                  disabled={selectedApprovalRequest.status !== 'Pending'}
                >
                  <Select.Option value="prior_appointment">Prior Appointment</Select.Option>
                  <Select.Option value="walk_in">Walk in</Select.Option>
                </Select>
              </div>
            );
          }

          // For other fields, make them editable text
          return (
            <Input
              value={text}
              onChange={(e) => handleFinalDataChange(e.target.value, record.field)}
            />
          );
        },
      },
    ];
  

  const addDoctorColumns = [
    {
      title: 'Fields',
      dataIndex: 'field',
      key: 'field',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'Doctor Details',
      dataIndex: 'doctorDetails',
      key: 'doctorDetails',
    },
  ];

  const handleSave = () => {
    setFinalOpdCharges(finalPrice);
    setEditPrice(false);
  };

  const data = [
    {
      field: 'OPD Charges',
      oldData: selectedApprovalRequest.oldOpdCharges,
      newData: selectedApprovalRequest.newOpdCharges,
      finalData: finalOpdCharges,
    },
    {
      field: 'Offline Discount',
      oldData: `${selectedApprovalRequest.oldOfflineDiscount} ${
        selectedApprovalRequest.oldOfflineDiscountOperation
          ? selectedApprovalRequest.oldOfflineDiscountOperation
          : ''
      }`,
      newData: `${selectedApprovalRequest.newOfflineDiscount} ${
        selectedApprovalRequest.newOfflineDiscountOperation
          ? selectedApprovalRequest.newOfflineDiscountOperation
          : ''
      }`,
      finalData: `${finalOfflineDiscount} ${
        finalOfflineDiscountOperation ? finalOfflineDiscountOperation : ''
      }`,
    },
    {
      field: 'Visit Payout Discount',
      oldData: `${selectedApprovalRequest.oldPayoutOfflineDiscount} ${
        selectedApprovalRequest.oldOfflineDiscountOperation
          ? selectedApprovalRequest.oldOfflineDiscountOperation
          : ''
      }`,
      newData: `${selectedApprovalRequest.newPayoutOfflineDiscount} ${
        selectedApprovalRequest.newOfflineDiscountOperation
          ? selectedApprovalRequest.newOfflineDiscountOperation
          : ''
      }`,
      finalData: `${finalPayoutOfflineDiscount} ${
        finalPayoutOfflineDiscountOperation ? finalPayoutOfflineDiscountOperation : ''
      }`,
    },
    {
      field: 'Follow up Discount',
      oldData: `${selectedApprovalRequest.oldOfflineFollowUpDiscount} ${
        selectedApprovalRequest.oldFOfflineDiscountOperation
          ? selectedApprovalRequest.oldFOfflineDiscountOperation
          : ''
      }`,
      newData: `${selectedApprovalRequest.newOfflineFollowUpDiscount} ${
        selectedApprovalRequest.newFOfflineDiscountOperation
          ? selectedApprovalRequest.newFOfflineDiscountOperation
          : ''
      }`,
      finalData: `${finalFollowUpDiscount} ${
        finalFollowUpDiscountOperation ? finalFollowUpDiscountOperation : ''
      }`,
    },
    {
      field: 'Follow up Days',
      oldData: selectedApprovalRequest.oldOfflineFollowUpDays,
      newData: selectedApprovalRequest.newOfflineFollowUpDays,
      finalData: finalFollowUpDays,
    },
    {
      field: 'Appointment Type',
      oldData: selectedApprovalRequest.oldAppointmentType,
      newData: selectedApprovalRequest.newAppointmentType,
      finalData: finalAppointmentType,
    },
    {
      field: 'Onboarding Status',
      oldData: selectedApprovalRequest.previousOnboardingStatus,
      newData: selectedApprovalRequest.newOnboardingStatus,
      finalData: selectedApprovalRequest.newOnboardingStatus,
    },
    {
      field: 'Payout To',
      oldData: selectedApprovalRequest.previousFullfillmentType,
      newData: selectedApprovalRequest.newFullfillmentType,
      finalData: selectedApprovalRequest.newFullfillmentType,
    },
  ];

  const doctorProfile = [
    {
      field: 'Doctor Name',
      doctorDetails: doctorDetail.name,
    },
    {
      field: 'Gender',
      doctorDetails: doctorDetail.gender,
    },
    {
      field: 'Vertical Name',
      doctorDetails: doctorDetail.verticalName,
    },
    {
      field: 'Phone Number',
      doctorDetails: doctorDetail.phone,
    },
    {
      field: 'Practice Years',
      doctorDetails: doctorDetail.practiceYears,
    },
    {
      field: 'Description',
      doctorDetails: doctorDetail.description,
    },
    {
      field: 'Profile Image',
      doctorDetails: doctorDetail.profileImg,
    },
    {
      field: 'Qualifications',
      doctorDetails: doctorDetail.qualifications,
    },
    {
      field: 'Opd Charges',
      doctorDetails: doctorCenterDetail.opdCharges,
    },
    {
      field: 'Center Name',
      doctorDetails: doctorCenterDetail.title,
    },
  ];

  const tableColumns = [
    {
      accessor: 'requestId',
      filterable: true,
      Header: 'Request Id',
      Cell: (row) => {
        return (
          <div style={{ textAlign: 'center' }}>
            <Button
              className="request-id-button"
              onClick={() => {
                setRemark(null);
                setSelectedRequestId(row.original.requestId);
              }}
            >
              {row.original.requestId}
            </Button>
          </div>
        );
      },
      Filter: ({ filter, onChange }) => {
        // console.log({ row });
        return (
          <input
            placeholder="Search..."
            value={filter ? filter.value : ''}
            onChange={(event) => onChange(event.target.value)}
          />
        );
      },
    },
    {
      accessor: 'priority',
      filterable: true,
      Header: 'Priority',
      Cell: (row) => {
        const value = row.value ? row.value.toString().toLowerCase() : '';
        let color = '';
        let display = '';
        if (value === 'high') {
          color = '#ff4d4f'; // red
          display = 'HIGH';
        } else if (value === 'medium') {
          color = '#faad14'; // yellow
          display = 'MEDIUM';
        } else if (value === 'low') {
          color = '#52c41a'; // green
          display = 'LOW';
        } else {
          color = '#d9d9d9'; // gray
          display = value.toUpperCase();
        }
        return (
          <span style={{
            color: '#fff',
            background: color,
            padding: '2px 10px',
            borderRadius: '6px',
            fontWeight: 600,
            display: 'inline-block',
            minWidth: 70,
            textAlign: 'center'
          }}>
            {display}
          </span>
        );
      }
    },
    {
      accessor: 'doctorName',
      filterable: true,
      textAlign: 'center',
      Header: 'Doctor Name',
      Filter: ({ filter, onChange }) => {
        // console.log({ row });
        return (
          <input
            placeholder="Search..."
            // onChange={(event) => {
            //   const filteredData = approvalRequests.filter((item) =>
            //     item.doctorName
            //       .toLowerCase()
            //       .includes(event.target.value.toLowerCase())
            //   );
            //   setCombinedApprovalRequest(filteredData);
            // }}
            value={filter ? filter.value : ''}
            onChange={(event) => onChange(event.target.value)}
          />
        );
      },
    },
    {
      accessor: 'centerName',
      sortable: true,
      filterable: true,
      Header: 'Center Name',
      Filter: ({ filter, onChange }) => {
        // console.log({ row });
        return (
          <input
            placeholder="Search..."
            // onChange={(event) => {
            //   const filteredData = approvalRequests.filter((item) =>
            //     item.centerName
            //       .toLowerCase()
            //       .includes(event.target.value.toLowerCase())
            //   );
            //   setCombinedApprovalRequest(filteredData);
            // }}
            value={filter ? filter.value : ''}
            onChange={(event) => onChange(event.target.value)}
          />
        );
      },
    },
    {
      accessor: 'createdAt',
      filterable: true,
      Header: 'Requested Date',
      Filter: ({ filter, onChange }) => {
        const handleDateChange = (date, dateString) => {
          onChange(dateString);
        };

        return (
          <DatePicker
            onChange={handleDateChange}
            format="YYYY-MM-DD"
            style={{ width: '100%' }}
          />
        );
      },
      filterMethod: (filter, row) => {
        if (!filter.value) return true;
        const rowDate = moment(row.createdAt).format('YYYY-MM-DD');
        const filterDate = moment(filter.value).format('YYYY-MM-DD');
        return rowDate === filterDate;
      },
    },

    {
      accessor: 'reason',
      filterable: false,
      Header: 'Reason',
    },
    {
      accessor: 'requestType',
      Header: 'Request Type',
      filterable: true,
      //sortable: true,
      filterMethod: (filter, row) => {
        if (filter.value == 'All-Requests') {
          return true;
        }
        return row.requestType === filter.value;
      },
      Filter: ({ filter, onChange }) => {
        return (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : 'All-Requests'}>
            <option value="All-Requests">All Requests</option>
            <option value="center-deOnboarding">Center deOnboarding</option>
            <option value="Price-Change-Request">Price Change Request</option>
            <option value="Center_Onboarding_Request">Center Onboarding Request</option>
            <option value="Add-Doctor-Request">Add Doctor Request</option>
            <option value="Inactive-Doctor-Request">Inactive Doctor Request</option>
            <option value="center-fulfilment-approval-request">center fulfilment approval request</option>
            <option value="center-discount-update">Center Discount Update</option>
          </select>
        );
      },
    },
    {
      accessor: 'requestComingFrom',
      Header: 'Source',
      filterable: true,
      //sortable: true,
      filterMethod: (filter, row) => {
        if (filter.value == 'All') {
          return true;
        }
        return row.requestType === filter.value;
      },
      Filter: ({ filter, onChange }) => {
        return (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : 'All'}>
            <option value="All">All</option>
            <option value="ops-dashboard">Ops Dashboard</option>
            <option value="kea-app">Kea App</option>
            <option value="hospital-dashboard">Hospital Dashboard</option>
            <option value="api-script">API Script</option>
          </select>
        );
      },
    },
    {
      accessor: 'status',
      Header: 'Status',
      filterable: true,
      sortable: true,
      filterMethod: (filter, row) => {
        if (filter.value === 'all') {
          return true;
        }
        return row.status === filter.value;
      },
      Filter: ({ filter, onChange }) => {
        return (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : 'all'}
          >
            <option value="all">All Requests</option>
            <option value="Pending">Pending</option>
            <option value="Rejected">Rejected</option>
            <option value="Approved">Approved</option>
          </select>
        );
      },

      Cell: (row) =>
        row.original.status === 'Pending' ? (
          <Tag color="red">{row.original.status}</Tag>
        ) : row.original.status === 'Approved' ? (
          <Tag color="cyan">{row.original.status}</Tag>
        ) : row.original.status === 'Rejected' ? (
          <Tag color="magenta">{row.original.status}</Tag>
        ) : (
          <Tag color="yellow">{row.original.status}</Tag>
        ),
    },
    {
      accessor: 'remark',
      filterable: false,
      Header: 'Admin Remark',
    },
    {
      accessor: 'requestBy',
      filterable: true,
      Header: 'Requested By',
    },
    {
      accessor: 'approvedAt',
      filterable: true,
      Header: 'Approved At',
      Cell: (row) => {
      if (row.original.approvedAt) {
        // Parse as UTC and add 5 hours 30 minutes for IST
        const date = moment.utc(row.original.approvedAt).add(5, 'hours').add(30, 'minutes');
        if (date.isValid()) {
          return date.format('DD-MM-YYYY HH:mm:ss');
        }
        return row.original.approvedAt;
      }
      return '';
  },
  },
    {
      accessor: 'approvedBy',
      filterable: false,
      Header: 'Claimed By',
    },
  ];

  const handleRequestCancellation = async () => {
    if (selectedApprovalRequest.status === 'Pending') {
      setRejecting(true);
      try {
        let data = {};
        if (selectedApprovalRequest.requestType === 'center-fulfilment-approval-request') {
          data = await centerFulfilmentCencelRequest({
            requestId: selectedApprovalRequest.requestId,
            centerId: selectedApprovalRequest.centerId,
            requestType: selectedApprovalRequest.requestType,
            status: 'Rejected',
            remark: remark,
            approvedAt : moment().format('YYYY-MM-DD HH:mm:ss')
          });
        } else {
          data = await updateRequestStatus({
            requestId: selectedRequestId,
            doctorId: selectedApprovalRequest.doctorId,
            centerId: selectedApprovalRequest.centerId,
            status: 'Rejected',
            remark: remark,
            approvedAt : moment().format('YYYY-MM-DD HH:mm:ss')
          });
        }
        if (data.body.status === 200 || data.body.message.toLowerCase() == 'success') {
          setSelectedApprovalRequest({});
          setSelectedRequestId('');
          setShowModal(false);
          setShowHandleRequestApproval(true);
          setShowHandleRequestApprovalMessage('Request rejected successfully!');
          fetchAllRequests();
        } else {
          setShowHandleRequestApprovalMessage('Request rejected successfully!');
          //alert('Request is already approved or rejected!');
        }
      } catch (err) {
        // Service layer already shows its own Modal.error() via showError()
        // so just close the modal to avoid two error popups
        setShowModal(false);
      } finally {
        setRejecting(false);
      }
    }
  };

  const handleRequestApproval = async () => {
    setApproving(true);
    setShowModal(false);
    setShowHandleRequestApproval(true);
    setShowHandleRequestApprovalMessage("Wait....");
    try {
    if (selectedApprovalRequest.status === 'Pending') {
      const body = {
        doctorId: selectedApprovalRequest.doctorId,
        active: 1,
        centerId: selectedApprovalRequest.centerId,
        opdCharges: selectedApprovalRequest.newOpdCharges,
        onlineOpdCharges: selectedApprovalRequest.newOnlineCharges,
        offlineDiscount: selectedApprovalRequest.newOfflineDiscount,
        offlineDiscountOperation:
          selectedApprovalRequest.newOfflineDiscountOperation,
        payoutOfflineDiscount: selectedApprovalRequest.newPayoutOfflineDiscount,
        onlineDiscount: selectedApprovalRequest.newOnlineDiscount,
        onlineDiscountOperation:
          selectedApprovalRequest.newOnlineDiscountOperation,
        fDiscount: selectedApprovalRequest.newOfflineFollowUpDiscount,
        fDiscountOperation:
          selectedApprovalRequest.newFOfflineDiscountOperation,
        fDays: selectedApprovalRequest.newOfflineFollowUpDays,
        onlineFDiscount: selectedApprovalRequest.newOnlineFollowUpDiscount,
        onlineFDiscountOperation:
          selectedApprovalRequest.newFOnlineDiscountOperation,
        onlineFDays: selectedApprovalRequest.newOnlineFollowUpDays,
        fulfilmentType: selectedApprovalRequest.newFullfillmentType,
        status: selectedApprovalRequest.newOnboardingStatus,
        remark: remark,
        onlineCorporatePayout: selectedApprovalRequest.newOnlineCorporatePayout,
        onlineRetailPayout: selectedApprovalRequest.newOnlineRetailPayout,
        telehealth: selectedApprovalRequest.telehealth,
        priceChangeReason: selectedApprovalRequest.reason,
        requestId: selectedRequestId,
        finalOpdCharges: finalOpdCharges,
        appointmentType : selectedApprovalRequest.newAppointmentType,
        approvedAt : moment().format('YYYY-MM-DD HH:mm:ss'),
      };
      let data = {};
      if (selectedApprovalRequest.requestType === 'center-deOnboarding') {
        body.active = 0;
        data = await changeNetworkCenterStatus(
          body.centerId,
          body.active,
          body.requestId,
          remark,
          body.approvedAt
        );
      } else if (
        selectedApprovalRequest.requestType === 'Center_Onboarding_Request'
      ) {
        data = await makeCenterStatusActive(
          body.centerId,
          body.active,
          body.requestId,
          remark,
          body.approvedAt
        );
      } else if (
        selectedApprovalRequest.requestType === 'Add-Doctor-Request' ||
        selectedApprovalRequest.requestType === 'Inactive-Doctor-Request'
      ) {
        data = await doctorPracticeApproveRequestStatus({
          doctorId: selectedApprovalRequest.doctorId,
          centerId: selectedApprovalRequest.centerId,
          active:
            selectedApprovalRequest.requestType === 'Add-Doctor-Request'
              ? 1
              : 0,
          approvalRequestId: selectedRequestId,
          status: 'Approved',
          remark: remark,
          approvedAt : moment().format('YYYY-MM-DD HH:mm:ss'),
        });
      } else if (selectedApprovalRequest.requestType === 'center-fulfilment-approval-request') {
        data = await centerFulfilmentApproveRequestStatus({
          requestId: selectedApprovalRequest.requestId,
          centerId: selectedApprovalRequest.centerId,
          requestType: selectedApprovalRequest.requestType,
          updateAll: selectedApprovalRequest.updateAll ? true : false,
          status: 'Approved',
          remark: remark
        });

      }else if (selectedApprovalRequest.requestType === 'center-discount-update') {
        const discountPayload = {
          offlineDiscount: selectedApprovalRequest.newOfflineDiscount,
          offlineDiscountOperation:
            selectedApprovalRequest.newOfflineDiscountOperation,
          payoutOfflineDiscount: selectedApprovalRequest.newPayoutOfflineDiscount,
          centerId: selectedApprovalRequest.centerId,
          requestId: selectedRequestId,
        };
        data =  await updateDiscountForAllSpecialists(discountPayload);
      } else if(selectedApprovalRequest.requestType === 'Price-Change-Request') {
        body.fDays = finalFollowUpDays;
        body.offlineDiscount = finalOfflineDiscount;
        body.offlineDiscountOperation = finalOfflineDiscountOperation;
        body.payoutOfflineDiscount = finalPayoutOfflineDiscount;
        body.fDiscount = finalFollowUpDiscount;
        body.fDiscountOperation = finalFollowUpDiscountOperation;
        body.appointmentType = finalAppointmentType;
        body.approvedAt = moment().format('DD-MM-YYYY');
        data = await approveRequestStatus(body);
      } else {
         data = await approveRequestStatus(body);
      }

      if (selectedApprovalRequest.requestType == 'center-fulfilment-approval-request') {

        if (data.body && data.body.data && ['failure','servererror'].includes(data.body.message.toLowerCase())) {
          setShowHandleRequestApprovalMessage(data.body.data.errorMessage);
          fetchAllRequests();
          return;
        }

        if (data.body && data.body.includes('\r\n')) {
          const responses = data.body.split('\r\n');
          console.log("responses", responses)

          responses.forEach(async (response) => {
            const parsedResponse = JSON.parse(response);
            if (parsedResponse.message.toLowerCase() == "success") {
              const res = await centerFulfilmentApproveRequest({
                requestId: selectedApprovalRequest.requestId,
                centerId: selectedApprovalRequest.centerId,
                requestType: selectedApprovalRequest.requestType,
                updateAll: selectedApprovalRequest.updateAll,
                status: 'Approved',
                remark: remark,
                approvedAt : moment().format('YYYY-MM-DD HH:mm:ss')
              });
              if (res.body.message.toLowerCase() === 'success') {
                setShowHandleRequestApprovalMessage("Request approved successfully!");
                fetchAllRequests();
              }
              return;
            } else {
              console.log("Failure:", response);
            }
          });
        }

      }

      console.log(data,'data');

      if (data.body.message.toLowerCase() === 'success') {
        setSelectedApprovalRequest({});
        setSelectedRequestId('');
        setShowHandleRequestApprovalMessage("Request approved successfully!");
        fetchAllRequests();

      } else if (data.body.message.toLowerCase() === 'servererror') {
        setShowHandleRequestApprovalMessage(data.body.errorMessage || 'Something went wrong. Please try again.');
        fetchAllRequests();
      } else if (data.body.message.toLowerCase() === 'failure') {
        setShowHandleRequestApprovalMessage(data.body?.data?.errorMessage || data.body?.errorMessage || 'Something went wrong. Please try again.');
        fetchAllRequests();
      }
    } else {
      fetchAllRequests();
      setShowHandleRequestApproval(true)
      setShowHandleRequestApprovalMessage("Cannot re-approve a request that has already been approved or rejected.");
    }
    } catch (err) {
      // Service layer already shows its own Modal.error() via showError()
      // so just close our status modal to avoid showing two error modals
      setShowHandleRequestApproval(false);
    } finally {
      setApproving(false);
    }
  };

  const handleRequestApprovalStatus = async () => {
    setShowHandleRequestApproval(false);
    setShowModal(false);
    setSelectedRequestId(null);
    setSelectedApprovalRequest({});

  }

  const centerFulfilmentField = [
    'oldTdsPercentage',
    'newTdsPercentage',
    'oldPayeeName',
    'newPayeeName',
    'oldAccountNumber',
    'newAccountNumber',
    'oldAccountType',
    'newAccountType',
    'oldIfscCode',
    'newIfscCode',
    'oldPreferredPayment',
    'newPreferredPayment',
    'oldPaymentCycle',
    'newPaymentCycle',
    'oldBankName',
    'newBankName',
    'oldVisitSpoc',
    'newVisitSpoc',
    'oldMasterHospital',
    'newMasterHospital',
    'oldInvoiceMandatory',
    'newInvoiceMandatory',
    'oldUpiAddress',
    'newUpiAddress',
    'oldRemarks',
    'newRemarks',
    'oldBranchName',
    'newBranchName',
    'oldMaternityDiscount',
    'newMaternityDiscount',
  ];
  const centerFulfilmentFieldData = {};
  const fulfilmentTableData = [];

  if (selectedApprovalRequest.requestType == 'center-fulfilment-approval-request') {
    Object.keys(selectedApprovalRequest).forEach(key => {
      if (centerFulfilmentField.includes(key) && (selectedApprovalRequest["old" + key.substring(3)] !== null || selectedApprovalRequest["new" + key.substring(3)] !== null)) {
        centerFulfilmentFieldData[key] = selectedApprovalRequest[key];
      }
    });
    for (const key in centerFulfilmentFieldData) {
      if (key.startsWith("new")) {
        const oldKey = "old" + key.substring(3);
        if (oldKey in centerFulfilmentFieldData) {
          const updatedField = key.substring(3);
          fulfilmentTableData.push({ [key]: centerFulfilmentFieldData[key], [oldKey]: centerFulfilmentFieldData[oldKey], "updatedField": updatedField });
        }
      }
    }
  }

  return (
    <Layout>
      <div>
        <HeaderComponent />
        <div style={{
          display: 'flex',
        }}>
          <div style={{ zIndex: 100}}>

            <SidebarComponent isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
          </div>
          <div style={{ width: '100%' }}>

      <Content className="site-layout-background">
        <PageHeader className="site-page-header" title="Approval Requests" />
        <ReactTable
          data={approvalRequests}
          columns={tableColumns}
          loading={loading}
          manual
          onFilteredChange={onFilteredChange}
          pages={pages}
          onPageChange={onPageChange}
          onFetchData={fetchTableData}
          className="-striped -highlight"
          textAlign="center"
          minRows={1}
          showPaginationTop
          showPaginationBottom
        />
        <Modal
          title={
            selectedApprovalRequest.requestType == 'Price-Change-Request' ||
              selectedApprovalRequest.requestType == 'Add-Doctor-Request'
              ? `Approval Request for Change in Doctor Details : ${selectedRequestId}`
              : `Approval Request for Change in Center Details : ${selectedRequestId}`
          }
          visible={showModal}
          okText="Approve"
          cancelText="Reject"
          onCancel={(e) => {
            if (e.currentTarget.id === 'discardButton') {
              handleRequestCancellation();
            } else {
              setShowModal(false);
              setSelectedRequestId(null);
              setSelectedApprovalRequest({});
            }
          }}
          okButtonProps={{ loading: approving, disabled: approving || rejecting }}
          cancelButtonProps={{ id: 'discardButton', loading: rejecting, disabled: approving || rejecting }}
          onOk={handleRequestApproval}
          style={{
            minWidth: selectedApprovalRequest.requestType === 'Price-Change-Request' ? '700px' : 'auto',
          }}
        >
          <Row>
            {selectedApprovalRequest.requestType ===
              'Center_Onboarding_Request' && (
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label
                    style={{
                      minWidth: '200px',
                      fontSize: '18px',
                      marginBottom: '10px',
                    }}
                  >
                    {' '}
                    Center Activation Request
                  </label>
                </div>
              )}
            <div style={{ marginBottom: '5px', display: 'flex' }}>
              <label style={{ minWidth: '200px' }}> Center Id :</label>
              <label style={{ wordBreak: "break-word" }}>{updateAllCenter ? updateAllCenterIdData : selectedApprovalRequest.centerId}</label>
            </div>
            <div style={{ marginBottom: '5px', display: 'flex' }}>
              <label style={{ minWidth: '200px' }}>
                {' '}
                Network Center Name :
              </label>
              <label style={{ wordBreak: "break-word" }} >{updateAllCenter ? updateAllCenterNameData : selectedApprovalRequest.centerName}</label>
            </div>
            {(selectedApprovalRequest.requestType == 'center-fulfilment-approval-request' || selectedApprovalRequest.requestType == "center-discount-update") &&
              <div style={{ marginBottom: '5px', display: 'flex' }}>
                <label style={{ minWidth: '200px' }}>
                  {' '}
                  Requested By :
                </label>
                <label>{selectedApprovalRequest.requestBy}</label>
              </div>
            }
            {selectedApprovalRequest.requestType == 'center-fulfilment-approval-request' && showModal == true &&
              <div>
                <style>
                  {`
                      table {
                        width: 100%;
                        border-collapse: collapse;
                        border-radius: 5px;
                        
                      }
                      th, td {
                        border: 1px solid black;
                        padding: 8px;
                        text-align: center;
                      }
                      th {
                        background-color: #f2f2f2;

                      }
                  `}
                </style>
                <table>
                  <thead>
                    <tr>
                      <th>Updated Field</th>
                      <th>Old Value</th>
                      <th>New Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fulfilmentTableData.map((item, index) => (
                      <tr key={index}>
                        <td>{item.updatedField}</td>
                        <td>{item[`old${item.updatedField}`]}</td>
                        <td>{item[`new${item.updatedField}`]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            }
            {selectedApprovalRequest.requestType ===
              'Center_Onboarding_Request' &&
              centerDetail && (
                <>
                  <div style={{ marginBottom: '5px', display: 'flex' }}>
                    <label style={{ minWidth: '200px' }}> Address :</label>
                    <label>{centerDetail.address}</label>
                  </div>
                  <div style={{ marginBottom: '5px', display: 'flex' }}>
                    <label style={{ minWidth: '200px' }}>
                      {' '}
                      Contact Number :
                    </label>
                    <label>{centerDetail.contactNumber}</label>
                  </div>

                  <div
                    style={{
                      marginBottom: '5px',
                      marginTop: '10px',
                      display: 'flex',
                    }}
                  >
                    <label
                      style={{
                        minWidth: '200px',
                        fontSize: '18px',
                        marginBottom: '10px',
                      }}
                    >
                      Center Mou Documents
                    </label>
                  </div>
                  <div style={{ marginBottom: '5px', display: 'flex' }}>
                    <label
                      style={{
                        minWidth: '200px',
                        marginRight: '10px',
                        fontWeight: 800,
                      }}
                    >
                      Document Category
                    </label>
                    <label
                      style={{
                        minWidth: '200px',
                        marginRight: '10px',
                        fontWeight: 800,
                      }}
                    >
                      Document Name
                    </label>
                    <div style={{ display: 'flex', fontWeight: 800 }}>
                      Document Link
                    </div>
                  </div>
                  {centerMouDetail &&
                    centerMouDetail.length > 0 &&
                    centerMouDetail.map((item, index) => {
                      return (
                        <div
                          style={{ marginBottom: '5px', display: 'flex' }}
                          key={item.moudId}
                        >
                          <label
                            style={{ minWidth: '200px', marginRight: '10px' }}
                          >
                            {item.category}
                          </label>
                          <label
                            style={{ minWidth: '200px', marginRight: '10px' }}
                          >
                            {item.name}
                          </label>
                          <div style={{ display: 'flex' }}>
                            {item.mouFiles && item.mouFiles.length > 0
                              ? item.mouFiles.map((item1, index2) => {
                                return (
                                  <a
                                    href={item1.link}
                                    target="_blank"
                                    style={{ marginRight: '10px' }}
                                  >
                                    Link{index2 + 1}
                                  </a>
                                );
                              })
                              : 'NA'}
                          </div>
                        </div>
                      );
                    })}
                </>
              )}
            {(selectedApprovalRequest.requestType == 'Add-Doctor-Request' ||
              selectedApprovalRequest.requestType ==
              'Inactive-Doctor-Request') && (
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}> Doctor Id :</label>
                  <label>{selectedApprovalRequest.doctorId}</label>
                </div>
              )}
            {(selectedApprovalRequest.requestType === 'Price-Change-Request' ||
              selectedApprovalRequest.requestType == 'Add-Doctor-Request' ||
              selectedApprovalRequest.requestType ==
              'Inactive-Doctor-Request') && (
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}> Doctor Name :</label>
                  <label>{selectedApprovalRequest.doctorName}</label>
                </div>
              )}
            {selectedApprovalRequest.requestType !== 'Center_Onboarding_Request'
              || selectedApprovalRequest.requestType !== 'center-fulfilment-approval-request' && (
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}> Reason :</label>
                  <label>{selectedApprovalRequest.reason}</label>
                </div>
              )}
            {selectedApprovalRequest.requestType === 'Price-Change-Request' && (
              <div style={{ marginBottom: '5px', display: 'flex' }}>
                <label style={{ minWidth: '200px' }}> Previous Price :</label>
                <label>
                  {selectedApprovalRequest.lastPrice
                    ? selectedApprovalRequest.lastPrice
                    : 'Not Available'}
                </label>
              </div>
            )}
            {selectedApprovalRequest.requestType === 'Price-Change-Request' && (
              <div style={{ marginBottom: '5px', display: 'flex' }}>
                <label style={{ minWidth: '200px' }}> Last Updated :</label>
                <label>
                  {selectedApprovalRequest.priceLastUpatedDate
                    ? new Date(
                      selectedApprovalRequest.priceLastUpatedDate
                    ).toLocaleDateString()
                    : 'Not Available'}
                </label>
              </div>
            )}
            {(selectedApprovalRequest.requestType === 'center-discount-update' ||
              selectedApprovalRequest.requestType === 'Price-Change-Request') && (
              <>
              <div style={{ marginBottom: '5px', display: 'flex' }}>
                <label style={{ minWidth: '200px' }}>Old Offline Discount :</label>
                <label>
                  {`${selectedApprovalRequest.oldOfflineDiscount} ${selectedApprovalRequest.oldOfflineDiscountOperation}`}
                </label>
              </div>
              <div style={{ marginBottom: '5px', display: 'flex' }}>
                <label style={{ minWidth: '200px' }}>New Offline Discount :</label>
                <label>
                  {`${selectedApprovalRequest.newOfflineDiscount} ${selectedApprovalRequest.newOfflineDiscountOperation}`}
                </label>
              </div>
              <div style={{ marginBottom: '5px', display: 'flex' }}>
                <label style={{ minWidth: '200px' }}>Old Visit Payout Discount :</label>
                <label>
                  {`${selectedApprovalRequest.oldPayoutOfflineDiscount} ${selectedApprovalRequest.oldOfflineDiscountOperation}`}
                </label>
              </div>
              <div style={{ marginBottom: '5px', display: 'flex' }}>
                <label style={{ minWidth: '200px' }}>New Visit Payout Discount :</label>
                <label>
                  {`${selectedApprovalRequest.newPayoutOfflineDiscount} ${selectedApprovalRequest.newOfflineDiscountOperation}`}
                </label>
              </div>
              <div style={{ marginBottom: '5px', display: 'flex' }}>
                <label style={{ minWidth: '200px' }}> Discounts values :</label>
                <label>
                  {selectedApprovalRequest.remark}
                </label>
              </div>
              </>
            )}
          </Row>
          {selectedApprovalRequest.requestType === 'Price-Change-Request' && (
            <>
              <Table columns={columns} dataSource={data} pagination={false} />
              {/* <Form.Item label="Final Opd Charges">
                <Input
                  style={{ width: '50%', marginRight: '20px' }}
                  placeholder="Final Price"
                  disabled={!editPrice}
                  value={finalPrice}
                  onChange={(e) => {
                    setFinalPrice(e.target.value);
                  }}
                />
                <Button
                  disabled={selectedApprovalRequest.status != 'Pending'}
                  onClick={() => {
                    editPrice ? handleSave() : setEditPrice(true);
                  }}
                >
                  {editPrice ? 'Save' : 'Edit'}
                </Button>
              </Form.Item> */}
            </>
          )}
          {selectedApprovalRequest.requestType === 'Add-Doctor-Request' && (
            <>
              <Table
                columns={addDoctorColumns}
                dataSource={doctorProfile}
                pagination={false}
              />
            </>
          )}
          {selectedApprovalRequest.requestType != 'center-discount-update' && <Form.Item label="Remark">
            <Input
              style={{ width: '50%', marginRight: '20px' }}
              placeholder="Remark"
              value={remark}
              onChange={(e) => {
                setRemark(e.target.value);
              }}
            />
          </Form.Item>}
        </Modal>
        <Modal
          visible={showHandleRequestApproval}
          closable={false}
          maskClosable={false}
          centered
          width={320}
          footer={
            approving || rejecting ? null : (
              <div style={{ textAlign: 'center' }}>
                <Button
                  key="ok"
                  type={
                    ['request approved successfully!', 'request rejected successfully!'].includes(
                      showHandleRequestApprovalMessage.toLowerCase()
                    )
                      ? 'primary'
                      : 'danger'
                  }
                  style={{ minWidth: 100 }}
                  onClick={handleRequestApprovalStatus}
                >
                  OK
                </Button>
              </div>
            )
          }
        >
          {approving || rejecting ? (
            <div style={{ textAlign: 'center', padding: '24px 0 8px' }}>
              <Spin size="large" />
              <div style={{ marginTop: 20, fontSize: 15, fontWeight: 600, color: '#5a3fc0' }}>
                Processing request{dots}
              </div>
              <div style={{ marginTop: 8, fontSize: 13, color: '#8c8c8c' }}>
                Please wait, do not close this window.
              </div>
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '16px 0 8px' }}>
              <div
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: ['request approved successfully!', 'request rejected successfully!'].includes(
                    showHandleRequestApprovalMessage.toLowerCase()
                  )
                    ? '#52c41a'
                    : '#cf1322',
                }}
              >
                {showHandleRequestApprovalMessage}
              </div>
            </div>
          )}
        </Modal>
      </Content>
      {/* <ReactTable /> */}
      </div></div></div>
    </Layout>
  );
};

export default withRouter(ApprovalRequests);
